// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style-control {\n  height: 100%;\n  overflow: hidden;\n}\n.style-control .vc-sketch {\n  width: calc(100% - 20px);\n  background-color: transparent;\n  box-shadow: unset;\n}\n.style-control .vc-sketch .vc-input__label {\n  color: #fff;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
